import React from "react";

// Corner tag on every non-production build so testers never mistake the SIT
// site (and its test database) for the live shop.
const EnvBadge = () => {
  const env = process.env.REACT_APP_ENV;
  if (!env || env === "prod") return null;

  return (
    <div
      aria-hidden="true"
      style={{
        position: "fixed",
        left: "12px",
        bottom: "12px",
        zIndex: 100,
        padding: "4px 10px",
        borderRadius: "999px",
        backgroundColor: "#f59e0b",
        color: "#000",
        fontSize: "12px",
        fontWeight: 700,
        letterSpacing: "0.1em",
        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        pointerEvents: "none",
      }}
    >
      {env.toUpperCase()}
    </div>
  );
};

export default EnvBadge;
